import type { ParsedUrlQuery } from 'querystring';

import { parseDateRangeType, parseHideDelivered } from 'Components/Account/AccountPage.helpers';
import { AccountDateRange } from 'Types/account';

export const checkFiltersAreSelected = (query: ParsedUrlQuery): number => {
	let selectedFiltersCount = 0;

	if (parseDateRangeType(query, AccountDateRange.ALL) !== AccountDateRange.ALL) {
		selectedFiltersCount++;
	}

	if (parseHideDelivered(query)) {
		selectedFiltersCount++;
	}

	return selectedFiltersCount;
};
